import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import axios from "axios";
import AdminHeader from "./AdminHeader";
import { AuthContext } from "../../../context/Authcontext";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap"; // ✅ Use React-Bootstrap modal

export const base_url = process.env.REACT_APP_API_URL;

const Company = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [error, setError] = useState();

  const [permit, setPermit] = useState([]);
  const [agents, setAgents] = useState([]);
  const [allAgents, setAllAgents] = useState([]);

  const location = useLocation();
  let agentId;

  useEffect(()=>{
    agentId= location?.state?.id;
    
  },[location.state]);



  // For See More modal
  const [showSeeMoreModal, setShowSeeMoreModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState("");

  const { getRoles } = useContext(AuthContext);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");
    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];
      Object.values(Object.values(roles[0])[0]).forEach((roleObj) => {
        Object.values(roleObj).forEach((perm) => {
          allPermit.push(...Object.values(perm));
        });
      });
      setPermit(allPermit);
    } catch (error) {
      setError(error.message);
    }
  }, []);

  const fetchAgents = useCallback(async (id) => {
    const auth = localStorage.getItem("admin");
    try {
        // console.log('idd',id);
      const response = await axios.get(`${base_url}/admin/getParticularCustomers/${id}`, {
        headers: { Authorization: `${auth}` },
      });
      if (response?.data?.success) {
        const data = response?.data?.agents;
        setAgents(data);
        setAllAgents(data);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleSearch = (e) => {
    const search = e.target.value.toLowerCase();
    if (search === "") {
      setAgents(allAgents);
      return;
    }
    const filteredData = allAgents?.filter((value) => {
      if (
        value.customerid.toLowerCase().includes(search) ||
        value.customername.toLowerCase().includes(search) ||
        value.project_name.toLowerCase().includes(search) ||
        value.domain.toLowerCase().includes(search)
      ) {
        return value;
      }
      return false;
    });
    setAgents(filteredData);
  };

  const handleSeeMore = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowSeeMoreModal(true);
  };

  const truncateText = (text, length = 20) => {
    if (!text) return "";
    return text.length > length ? text.slice(0, length) + "..." : text;
  };

  useEffect(() => {

    fetchRoles();

    if(agentId){
        fetchAgents(agentId);
    }
  }, [fetchRoles, fetchAgents]);


//   console.log('idds',agentId);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <div className="wrapper bg-light min-vh-100">
        <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />

        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        >
          <div className="container py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1 className="h4 text-dark">
                <i className="fa fa-users text-primary me-2" />
                Partners
              </h1>
              {/* <button
                onClick={() => handleModal("add-customer", null)}
                className="btn btn-primary"
              >
                <i className="fa fa-plus me-1" /> Add Customer
              </button> */}
            </div>

            <div className="w-100 my-3 rounded">
              <input
                type="text"
                placeholder="Enter Customer ID or Customer Name or Project Name or Domain name"
                name="search"
                className="form-control rounded"
                onChange={handleSearch}
              />
            </div>

            <div className="table-responsive bg-white shadow-sm rounded">
              <table className="table table-striped table-hover bg-gray">
                <thead className="table-light bg-gray text-nowrap">
                  <tr className="text-center border">
                    <td className="border fw-bold p-3">Customer ID</td>
                    <td className="border fw-bold p-3">Customer Name</td>
                    <td className="border fw-bold p-3">Username</td>
                    <td className="border fw-bold p-3">Password</td>
                    <td className="border fw-bold p-3">Phone</td>
                    <td className="border fw-bold p-3">Wallet</td>
                    <td className="border fw-bold p-3">Status</td>
                    <td className="border fw-bold p-3">Verify Key</td>
                    <td className="border fw-bold p-3">Secret Key</td>
                    <td className="border fw-bold p-3">Project IP</td>
                    <td className="border fw-bold p-3">Domain Name</td>
                    <td className="border fw-bold p-3">Project Name</td>
                    <td className="border fw-bold p-3">Project URL</td>
                    <td className="border fw-bold p-3">Created By</td>
                    <td className="border fw-bold p-3">Date</td>
                  </tr>
                </thead>
                <tbody>
                  {agents.map((agent) => (
                    <tr key={agent.customerid} className="text-center border">
                      <td className="border">{agent.customerid}</td>
                      <td className="border">{agent.customername}</td>
                      <td className="border">{agent.username}</td>
                      <td className="border">{agent.plain_password}</td>
                      <td className="border">{agent.phone}</td>
                      <td className="border">{agent.wallet}</td>
                      <td className="border">{agent.status}</td>

                      {/* Public Key */}
                      <td className="border cursor-pointer" onClick={() =>
                            handleSeeMore("Public Key", agent.public_key)
                        }>
                        {truncateText(agent.public_key)}
                        {agent.public_key?.length > 20 && (
                          <button
                            className="border-0 p-0 ms-1"
                            style={{fontSize:'10px', color:'gray', textDecoration:'underline'}}
                            onClick={() =>
                              handleSeeMore("Public Key", agent.public_key)
                            }
                          >
                            See More
                          </button>
                        )}
                      </td>

                      {/* Private Key */}
                      <td className="border cursor-pointer" onClick={() =>
                            handleSeeMore("Private Key", agent.private_key)
                        }>
                        {truncateText(agent.private_key)}
                        {agent.private_key?.length > 20 && (
                          <button
                            className="border-0 p-0 ms-1"
                            style={{fontSize:'10px', color:'gray', textDecoration:'underline'}}
                            onClick={() =>
                              handleSeeMore("Private Key", agent.private_key)
                            }
                          >
                            See More
                          </button>
                        )}
                      </td>

                      <td className="border">{agent.ip}</td>
                      <td className="border">{agent.domain}</td>
                      <td className="border">{agent.project_name}</td>
                      <td className="border">{agent.project_url}</td>
                      <td className="border">{agent.created_by}</td>
                      <td className="border">{agent.date?.slice(0, 10)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* See More Modal */}
      <Modal
        show={showSeeMoreModal}
        onHide={() => setShowSeeMoreModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {modalContent}
          </pre>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Company;
